var _path, _path2, _path3, _path4, _path5, _mask, _g, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError5005(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 170,
    viewBox: "0 0 416 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.718 169.158C252.628 169.158 292.278 149.333 292.278 124.878C292.278 100.423 252.628 80.5984 203.718 80.5984C154.808 80.5984 115.158 100.423 115.158 124.878C115.158 149.333 154.808 169.158 203.718 169.158Z",
    fill: "#86A5BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.718 166.578C252.628 166.578 292.278 146.754 292.278 122.299C292.278 97.8434 252.628 78.0186 203.718 78.0186C154.808 78.0186 115.158 97.8434 115.158 122.299C115.158 146.754 154.808 166.578 203.718 166.578Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.782 99.2465C179.56 84.3391 227.875 84.3391 257.653 99.2465C271.565 106.193 278.973 115.149 279.894 124.252C281 113.859 273.629 103.282 257.653 95.3215C227.875 80.4325 179.652 80.4325 149.782 95.3215C133.879 103.282 126.472 113.859 127.541 124.252C128.462 115.149 135.869 106.193 149.782 99.2465Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.782 149.276C179.56 164.165 227.876 164.165 257.654 149.276C271.566 142.329 278.974 133.299 279.895 124.252C278.974 115.149 271.566 106.193 257.654 99.2465C227.876 84.3391 179.652 84.3391 149.782 99.2465C135.87 106.193 128.462 115.149 127.541 124.252C128.462 133.299 135.87 142.329 149.782 149.276Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3102 41.5345H35.6109V63.2532C38.0893 60.6444 41.4808 58.5573 45.7854 56.992C50.0901 55.4267 54.8512 54.644 60.0689 54.644C69.4608 54.644 77.2874 56.7963 83.5487 61.1009C89.9404 65.4055 94.6363 71.0798 97.6365 78.1237C100.637 85.1676 102.137 92.8638 102.137 101.212C102.137 116.604 97.7669 128.736 89.0273 137.606C80.2876 146.345 68.1564 150.715 52.6337 150.715C41.8069 150.715 32.4151 148.889 24.458 145.237C16.6315 141.454 10.6311 136.236 6.45692 129.583C2.28275 122.931 0.130443 115.3 0 106.691H37.3719C37.7632 109.691 39.0676 112.3 41.2852 114.517C43.5027 116.735 46.7638 117.844 51.0684 117.844C55.6339 117.844 59.0906 116.278 61.4386 113.148C63.7866 110.017 64.9605 105.843 64.9605 100.625C64.9605 95.5378 63.7213 91.6898 61.2429 89.0809C58.7645 86.3416 55.1773 84.972 50.4814 84.972C46.9594 84.972 44.0897 85.8851 41.8722 87.7113C39.7851 89.407 38.5459 91.5593 38.1545 94.1682H0.782657V7.68457H94.3102V41.5345Z",
    fill: "url(#paint3_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 0,
    width: 153,
    height: 161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.782 149.275C179.56 164.164 227.876 164.164 257.654 149.275C271.566 142.328 278.974 133.299 279.895 124.251C278.974 115.148 260.731 14.4469 246.818 7.49994C217.041 -7.40746 191.689 3.59186 161.818 18.4993C147.906 25.4462 128.462 115.148 127.541 124.251C128.462 133.299 135.87 142.328 149.782 149.275Z",
    fill: "url(#paint4_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.025 116.43C146.025 93.9938 150.591 76.3188 159.722 63.405C168.853 50.4911 183.202 44.0342 202.768 44.0342C222.334 44.0342 236.683 50.4911 245.814 63.405C255.076 76.3188 259.706 93.9938 259.706 116.43C259.706 139.127 255.141 156.932 246.01 169.846C236.879 182.76 222.465 189.217 202.768 189.217C183.071 189.217 168.657 182.76 159.526 169.846C150.526 156.932 146.025 139.127 146.025 116.43ZM221.747 116.43C221.747 104.69 220.508 95.7548 218.03 89.624C215.551 83.3627 210.464 80.2321 202.768 80.2321C195.072 80.2321 189.985 83.3627 187.506 89.624C185.028 95.7548 183.789 104.69 183.789 116.43C183.789 128.431 184.963 137.562 187.311 143.823C189.789 149.954 194.941 153.019 202.768 153.019C210.595 153.019 215.682 149.954 218.03 143.823C220.508 137.562 221.747 128.431 221.747 116.43Z",
    fill: "url(#paint5_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.025 75.43C302.025 52.9938 306.591 35.3188 315.722 22.405C324.853 9.4911 339.202 3.03418 358.768 3.03418C378.334 3.03418 392.683 9.4911 401.814 22.405C411.076 35.3188 415.706 52.9938 415.706 75.43C415.706 98.127 411.141 115.932 402.01 128.846C392.879 141.76 378.465 148.217 358.768 148.217C339.071 148.217 324.657 141.76 315.526 128.846C306.526 115.932 302.025 98.127 302.025 75.43ZM377.747 75.43C377.747 63.6901 376.508 54.7548 374.03 48.624C371.551 42.3627 366.464 39.2321 358.768 39.2321C351.072 39.2321 345.985 42.3627 343.506 48.624C341.028 54.7548 339.789 63.6901 339.789 75.43C339.789 87.4307 340.963 96.5617 343.311 102.823C345.789 108.954 350.941 112.019 358.768 112.019C366.595 112.019 371.682 108.954 374.03 102.823C376.508 96.5617 377.747 87.4307 377.747 75.43Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 115.151,
    y1: 122.306,
    x2: 292.278,
    y2: 122.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1BACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 127.43,
    y1: 104.203,
    x2: 280.005,
    y2: 104.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BCD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBD1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BBD1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C5D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 202.483,
    y1: 88.0245,
    x2: 204.953,
    y2: 160.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7992A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#627889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 15.17,
    y1: -27.895,
    x2: 108.531,
    y2: 180.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 202.483,
    y1: 88.0191,
    x2: 204.953,
    y2: 160.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7992A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#627889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 187.318,
    y1: -1.5,
    x2: 212.818,
    y2: 216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AA2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#8AA2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#2F4555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 327.17,
    y1: -29.6108,
    x2: 420.53,
    y2: 178.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError5005);
export default __webpack_public_path__ + "static/media/error_500_5.7f31066fdc382e8aaa5fea692932786e.svg";
export { ForwardRef as ReactComponent };